import { Box, Table, Text } from '@factorialco/deprecated-design-system'

import { formattedAmount } from 'modules/banking/lib/paymentHelpers'

interface SummaryMoneyCellProps {
  visible: boolean
  amount: number
  currency: string
  locale: string
}

export const SummaryMoneyCell = ({ visible, amount, currency, locale }: SummaryMoneyCellProps) => {
  if (!visible) return <Table.Cell noBorder paddingX="s4" paddingY="s2" width={100} />
  return (
    <Table.Cell noBorder paddingX="s4" paddingY="s2" width={100}>
      <Box textAlign="right" maxWidth="s120">
        <Text.Normal ellipsis weight="semibold" size="200" color="grey1000">
          {formattedAmount({
            amountCents: amount,
            currency: currency,
            locale,
          })}
        </Text.Normal>
      </Box>
    </Table.Cell>
  )
}
